import { useCallback, useState } from 'react';
import { useChainId } from 'src/hooks/chain';
import { useChangesSnackbar } from 'src/hooks/snackbar/useChangesSnackbar';
import { components } from 'src/infrastructure/rest-api/generated';
import { buildApiUrl, useApiMutation } from 'src/infrastructure/rest-api/useApi';

type UpdateChainFurnitureZoneInput = components['schemas']['UpdateChainFurnitureZoneInput'];

export const useChainFurnitureZoneUpdateChanges = () => {
    const chainId = useChainId();
    const showSnackbar = useChangesSnackbar();
    const [isUpdating, setIsUpdating] = useState(false);

    const [updateFurnitureZone] = useApiMutation('/api/inventorymanagement/chains/{chainId}/furniturezones', 'put', {
        update: (_data, variables, queryClient) => {
            queryClient.invalidateQueries({
                queryKey: [buildApiUrl('/api/inventorymanagement/chains/{chainId}/furniturezones', variables.path)],
            });
        },
    });

    const updateChanges = useCallback(
        async (input: UpdateChainFurnitureZoneInput) => {
            if (!input.id) return;
            setIsUpdating(true);

            try {
                const response = await updateFurnitureZone({ path: { chainId }, body: input });
                showSnackbar();
                return response;
            } catch (err) {
                showSnackbar(err);
            } finally {
                setIsUpdating(false);
            }
        },
        [chainId, showSnackbar, updateFurnitureZone]
    );

    return [updateChanges, { loading: isUpdating }] as const;
};
